module.exports = __webpack_public_path__ + "media/icons/building-e3957e46.svg";